// @ts-nocheck
/* eslint-disable spire/export-styles */
import { getIsWebCrawler } from "@insite/client-framework/Common/WebCrawler";
import { HasCategoryContext, withCategory } from "@insite/client-framework/Components/CategoryContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
// import Typography from "@insite/mobius/Typography"; // Valtech Custom Code
import * as React from "react";
import { connect } from "react-redux";

/* Valtech Custom Code */
import translate from "@insite/client-framework/Translate";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import {
    useBrandName,
    useIsReady,
    useSearchQuery,
} from "@toolkit/Framework/Store/Toolkit/Pages/ProductList/ProductListHooks";

export interface CategoryNameStyles {
    title?: TypographyPresentationProps;
}

export const categoryNameStyles: CategoryNameStyles = {
    title: {
        variant: "h1",
    },
};

const styles = categoryNameStyles;
/* Valtech Custom Code */

const mapStateToProps = (state: ApplicationState) => ({
    currentPage: getCurrentPage(state),
});

type Props = WidgetProps & HasCategoryContext & ReturnType<typeof mapStateToProps>;

const CategoryName = ({ category, currentPage }: Props) => {
    /* Valtech Custom Code */
    const isReady = useIsReady();
    const brandName = useBrandName();
    const searchQuery = useSearchQuery();

    if (!category && !isReady) {
        return null;
    }
    /* Valtech Custom Code */

    /* Valtech Removed - isSearchCrawler */

    /* Valtech Custom Code */
    return (
        <Typography
            {...styles.title}
            data-test-selector={`categoryName_${category?.shortDescription ?? category?.name}`}
        >
            {category?.shortDescription ||
                (brandName ? translate("{0} Products", brandName) : translate("Search Results"))}
            {searchQuery ? ` ${translate("for")} "${searchQuery}"` : null}
        </Typography>
    );
    /* Valtech Custom Code */
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withCategory(CategoryName)),
    definition: {
        group: "Category Details",
        icon: "folder-bookmark",
        allowedContexts: ["CategoryDetailsPage", "ProductDetailsPage", "ProductListPage"],
    },
};

export default widgetModule;
